import { gql } from '__generated__';

gql(`
  fragment CalenderEventFields on PublicEvent {
    id
    title
    start_date
    end_date
    location {
      id
      description
      city
    }
    logo_url
    header_url
    brand_color
    checkout_url
    sport_types
    average_rating
    trend_score
  }
`);

export default gql(`
  query GetCalendarPage(
    $search: String,
    $sport_types: [SportType!],
    $min_distance: Int,
    $max_distance: Int,
    $distances: [String!],
    $months: [String!],
    $page: Int,
    $per_page: Int,
    $countries: [String!],
    $sort: String,
  ) {
    sportTypes(active: true)
    eventCountries
    publicEvents(search: $search,
      sport_types: $sport_types,
      min_distance: $min_distance,
      max_distance: $max_distance,
      distances: $distances,
      months: $months,
      page: $page,
      per_page: $per_page,
      countries: $countries,
      sort: $sort,
    ) {
      current_page
      last_page
      per_page
      total
      data {
        ...CalenderEventFields
      }
    }
  }
`);
